module.exports = __webpack_public_path__ + "media/images/story/top/point_image_2-b96e59050b576fea9f4c02326f500826.jpg";